export default __webpack_public_path__ + "static/media/sass.ff456cc6.png";